import { render, staticRenderFns } from "./ItemMediaSwiper.vue?vue&type=template&id=738501a6&scoped=true&"
import script from "./ItemMediaSwiper.vue?vue&type=script&lang=js&"
export * from "./ItemMediaSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ItemMediaSwiper.vue?vue&type=style&index=0&id=738501a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738501a6",
  null
  
)

export default component.exports